export default __webpack_public_path__ + "static/media/blog-do-it-yourself-001.f3d5a0b7.jpg";